import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  getDocs,
  doc,
  setDoc,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import { useNavigate } from "react-router-dom";

const GroupEntry = () => {
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);

  const [groupName, setGroupName] = useState("");
  const [groupNameRuby, setGroupNameRuby] = useState("");
  const [entryClass, setEntryClass] = useState("QuartetContest");
  const [picName, setPicName] = useState("");
  const [picMail, setPicMail] = useState("");
  const [entryNumber, setEntryNumber] = useState("");
  const [quartetContestMemberTenor, setQuartetContestMemberTenor] =
    useState("");
  const [quartetContestMemberLead, setQuartetContestMemberLead] = useState("");
  const [quartetContestMemberBaritone, setQuartetContestMemberBaritone] =
    useState("");
  const [quartetContestMemberBass, setQuartetContestMemberBass] = useState("");
  const [chorusContestAttendance, setChorusContestAttendance] =
    useState<string>("");
  const [chorusDirector, setChorusDirector] = useState("");
  const [information, setInformation] = useState("");
  const [joinChampionship, setJoinChampionship] = useState(true);
  const [joinPreliminary, setJoinPreliminary] = useState(true);
  const [showCompleteModal, setShowCompleteModal] = useState(false);

  const getEntryCountForYearAndClass = async (
    year: number,
    entryClass: string,
  ): Promise<number> => {
    const start = new Date(`${year}-01-01T00:00:00`);
    const end = new Date(`${year + 1}-01-01T00:00:00`);

    const groupRef = collection(db, "groups");
    const classAndYearQuery = query(
      groupRef,
      where("entryClass", "==", entryClass),
      where("createdAt", ">=", start),
      where("createdAt", "<", end),
    );
    const snapshot = await getDocs(classAndYearQuery);
    return snapshot.size;
  };

  const handleSave = async () => {
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    let resolvedEntryNumber = entryNumber;

    if (!resolvedEntryNumber.trim()) {
      const thisYear = new Date().getFullYear();
      const count = await getEntryCountForYearAndClass(thisYear, entryClass);
      resolvedEntryNumber = String(count + 1);
    }

    if (sending) return;
    setSending(true);

    const groupId = await resolveGroupMaster();

    // ポータルログイン時のメールアドレス突き合わせのため、正規化して保存する
    const normalizedPicMail = picMail.trim().toLowerCase();

    const groupData = {
      groupId,
      entryNumber: resolvedEntryNumber,
      groupName,
      groupNameRuby,
      entryClass,
      joinChampionship,
      joinPreliminary,
      picName,
      picMail: normalizedPicMail,
      quartetContestMemberTenor,
      quartetContestMemberLead,
      quartetContestMemberBaritone,
      quartetContestMemberBass,
      chorusContestAttendance: Number(chorusContestAttendance) || 0,
      chorusDirector,
      information,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    const newId = uuidv4();
    await setDoc(doc(db, "groups", newId), groupData);

    navigate("/entry/complete");
  };

  const resolveGroupMaster = async (): Promise<string> => {
    // groupName で groupMaster を検索
    const q = query(
      collection(db, "groupMaster"),
      where("groupName", "==", groupName),
    );
    const snap = await getDocs(q);

    // 既存団体
    if (!snap.empty) {
      return snap.docs[0].id;
    }

    // 新規団体 → id 発行
    const newRef = doc(collection(db, "groupMaster"));

    await setDoc(newRef, {
      groupName,
      groupNameRuby,
      picName,
      picMail,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });

    return newRef.id;
  };

  return (
    <div className="table-contents">
      <div className="admin-edit entry-form">
        <div className="header-text">
          <h1>JBC 2026 参加申し込み</h1>
          <p>
            Japan Barbershop Convention 2026のエントリーフォームです。
            <br />
            詳しいレギュレーションについては
            <a
              href="https://www.singbarbershop.jp/jbc2026/%E3%83%AC%E3%82%AE%E3%83%A5%E3%83%AC%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3-regulation"
              target="break"
            >
              「JBC2026 レギュレーション」
            </a>
            をご確認ください。
          </p>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          <div className="form-contents middle-size">
            <label className="form-label required">グループ名</label>
            <input
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              required
            />
          </div>
          <div className="form-contents middle-size">
            <label className="form-label required">
              グループ名（ふりがな）
            </label>
            <input
              value={groupNameRuby}
              onChange={(e) => setGroupNameRuby(e.target.value)}
              required
            />
          </div>
          <div className="form-contents section-start">
            <label className="form-label required">エントリークラス</label>
            <div className="entry-class-options">
              <label
                className={`entry-class-option quartet ${
                  entryClass === "QuartetContest" ? "selected" : ""
                }`}
              >
                <input
                  type="radio"
                  value="QuartetContest"
                  checked={entryClass === "QuartetContest"}
                  onChange={() => setEntryClass("QuartetContest")}
                  required
                />
                Quartet Contest
              </label>
              <label
                className={`entry-class-option chorus ${
                  entryClass === "ChorusContest" ? "selected" : ""
                }`}
              >
                <input
                  type="radio"
                  value="ChorusContest"
                  checked={entryClass === "ChorusContest"}
                  onChange={() => setEntryClass("ChorusContest")}
                />
                Chorus Contest
              </label>
              <label
                className={`entry-class-option evaluation ${
                  entryClass === "EvaluationOnly" ? "selected" : ""
                }`}
              >
                <input
                  type="radio"
                  value="EvaluationOnly"
                  checked={entryClass === "EvaluationOnly"}
                  onChange={() => setEntryClass("EvaluationOnly")}
                />
                Evaluation Only
              </label>
            </div>
          </div>

          {entryClass !== "EvaluationOnly" && (
            <>
              <div className="form-contents">
                <div className="checkbox1">
                  <input
                    type="checkbox"
                    checked={joinChampionship}
                    onChange={(e) => setJoinChampionship(e.target.checked)}
                  />
                  <span>Championshipに参加する</span>
                </div>
              </div>
              <div className="form-contents">
                <div className="checkbox1">
                  <input
                    type="checkbox"
                    checked={joinPreliminary}
                    onChange={(e) => setJoinPreliminary(e.target.checked)}
                  />
                  <span>Preliminaryに参加する</span>
                </div>
              </div>
            </>
          )}
          <div className="form-contents middle-size  section-start">
            <label className="form-label required">連絡担当者名</label>
            <input
              value={picName}
              onChange={(e) => setPicName(e.target.value)}
            />
          </div>
          <div className="form-contents middle-size">
            <label className="form-label required">連絡担当者メール</label>
            <input
              value={picMail}
              onChange={(e) => setPicMail(e.target.value)}
              required
            />
          </div>
          {entryClass === "QuartetContest" && (
            <>
              <div className="form-contents middle-size section-start">
                <label className="form-label required">
                  カルテットメンバー
                </label>
              </div>
              <div className="form-contents middle-size second">
                <label className="form-label">メンバー1</label>
                <input
                  value={quartetContestMemberTenor}
                  onChange={(e) => setQuartetContestMemberTenor(e.target.value)}
                  required={entryClass === "QuartetContest"}
                />
              </div>

              <div className="form-contents middle-size second">
                <label className="form-label">メンバー2</label>
                <input
                  value={quartetContestMemberLead}
                  onChange={(e) => setQuartetContestMemberLead(e.target.value)}
                  required={entryClass === "QuartetContest"}
                />
              </div>

              <div className="form-contents middle-size second">
                <label className="form-label">メンバー3</label>
                <input
                  value={quartetContestMemberBaritone}
                  onChange={(e) =>
                    setQuartetContestMemberBaritone(e.target.value)
                  }
                  required={entryClass === "QuartetContest"}
                />
              </div>

              <div className="form-contents middle-size second">
                <label className="form-label">メンバー4</label>
                <input
                  value={quartetContestMemberBass}
                  onChange={(e) => setQuartetContestMemberBass(e.target.value)}
                  required={entryClass === "QuartetContest"}
                />
              </div>
            </>
          )}
          {entryClass !== "QuartetContest" && (
            <div className="form-contents short-size section-start">
              <label className="form-label required">出演者人数</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  value={chorusContestAttendance}
                  onChange={(e) => setChorusContestAttendance(e.target.value)}
                  required={entryClass !== "QuartetContest"}
                />
                <span>人</span>
              </div>
            </div>
          )}
          {entryClass !== "QuartetContest" && (
            <div className="form-contents middle-size">
              <label
                className={`form-label ${entryClass === "ChorusContest" ? "required" : ""}`}
              >
                Director氏名
              </label>
              <input
                value={chorusDirector}
                onChange={(e) => setChorusDirector(e.target.value)}
                required={entryClass === "ChorusContest"}
              />
            </div>
          )}
          <div className="form-contents section-start">
            <label className="form-label">連絡事項</label>
            <input
              value={information}
              onChange={(e) => setInformation(e.target.value)}
            />
          </div>
          <div className="edit-footer">
            <button type="submit">送信する</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GroupEntry;
